module.exports = __webpack_public_path__ + "img/fond_SL_Nextories4.jpg";